var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{key:_vm.formKey,attrs:{"type":"text","label":_vm.name,"rules":[
    function () { return (!!_vm.value && _vm.value.length >= 7 && _vm.value.length <= 15) ||
      _vm.$t('rules.mobile'); },
    function () { return Number.isInteger(Number(_vm.value)) || _vm.$t('rules.mobileNumber'); } ]},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }